import { useTranslation } from 'react-i18next';
import PageHero from '../../components/shared/PageHero';
import Sidebar from '../../components/shared/Sidebar';
import { Camera, MapPin, Users, Heart } from 'lucide-react';

export default function Campus() {
  const { t } = useTranslation();

  const galleryImages = [
    '/images/campus/building-01.jpg',
    '/images/campus/students-01.jpg',
    '/images/campus/classroom-01.jpg',
    '/images/campus/ceremony-01.jpg',
    '/images/campus/espace-01.jpg',
    '/images/campus/doc-gathering-01.jpg'
  ];

  return (
    <div className="flex flex-col bg-white">
      <PageHero 
        title={t('campus_title', 'Vie de Campus')}
        description={t('campus_subtitle', 'Un environnement d’apprentissage inspirant au cœur de Yaoundé.')}
        breadcrumbs={[{ label: t('nav_campus', 'Campus'), href: '/campus' }]}
        variant="light"
      />

      <main className="max-w-7xl mx-auto w-full py-20 px-6 lg:px-12 flex flex-col lg:flex-row gap-16">
        <Sidebar variant="programs" />

        <div className="flex-1 space-y-24 animate-in fade-in slide-in-from-right-8 duration-700 delay-200">
          
          {/* Main Info Grid */}
          <section className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="space-y-6">
              <h2 className="text-3xl font-black text-navy uppercase tracking-tight flex items-center gap-3">
                <MapPin className="w-8 h-8 text-gold" /> {t('campus_location_title')}
              </h2>
              <p className="text-gray-600 text-lg font-medium">
                {t('campus_location_address')}
              </p>
              <p className="text-gray-500 italic">
                {t('campus_location_desc')}
              </p>
              <div className="bg-gray-100 p-6 border-l-4 border-gold">
                <p className="font-bold text-navy italic">"{t('campus_visit_quote')}"</p>
              </div>
            </div>
            <div className="space-y-6">
              <h2 className="text-3xl font-black text-navy uppercase tracking-tight flex items-center gap-3">
                <Heart className="w-8 h-8 text-gold" /> {t('campus_spiritual_title')}
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed font-medium">
                {t('campus_spiritual_desc')}
              </p>
              <p className="text-gray-500 font-black uppercase text-[10px] tracking-[0.3em] text-gold">
                {t('campus_welcome_text')}
              </p>
            </div>
          </section>

          {/* Gallery Section */}
          <section id="gallery" className="space-y-12">
            <h2 className="text-3xl font-black text-navy uppercase tracking-tight border-b-2 border-gray-100 pb-4 flex items-center gap-4 italic">
              <Camera className="w-8 h-8 text-gold" /> {t('campus_gallery_title', 'Galerie Photos')}
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {galleryImages.map((img, idx) => (
                <div key={idx} className="group aspect-[4/3] overflow-hidden rounded-sm shadow-md hover:shadow-2xl transition-all cursor-pointer">
                  <img 
                    src={img} 
                    alt={`Campus ${idx + 1}`} 
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" 
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </section>

          {/* Associations Section */}
          <section id="associations" className="bg-navy p-12 md:p-20 text-white rounded-sm shadow-2xl relative overflow-hidden group">
            <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full -translate-y-1/2 translate-x-1/2 group-hover:scale-110 transition-transform duration-1000"></div>
            <div className="relative z-10 space-y-12">
               <h2 className="text-3xl md:text-4xl font-black uppercase tracking-tighter italic flex items-center gap-4">
                <Users className="w-10 h-10 text-gold" /> {t('campus_associations_title', 'Associations Étudiantes')}
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                <div className="p-8 bg-white/5 backdrop-blur-sm border border-white/10 rounded-sm hover:bg-white/10 transition-all group/card">
                  <h3 className="text-2xl font-black text-gold mb-4 uppercase group-hover/card:translate-x-2 transition-transform">{t('campus_association_bedir')}</h3>
                  <p className="text-white/80 font-medium">Bureau des Étudiants pour le Développement et l’Innovation Responsable.</p>
                </div>
                <div className="p-8 bg-white/5 backdrop-blur-sm border border-white/10 rounded-sm hover:bg-white/10 transition-all group/card">
                  <h3 className="text-2xl font-black text-gold mb-4 uppercase group-hover/card:translate-x-2 transition-transform">{t('campus_association_anipes')}</h3>
                  <p className="text-white/80 font-medium">Association Nationale pour l’Inclusion et la Promotion de l’Enseignement Supérieur.</p>
                </div>
              </div>
            </div>
          </section>

        </div>
      </main>
    </div>
  );
}
